export default {
	name: "Deutsch",

	'global.itemCounts': `{total, plural,
		=0 {kein Inhalt}
		other {}
	}{collections, plural,
		=0 {}
		one {eine Sammlung}
		other {{collections} Sammlungen}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {eine Geschichte}
		other {{stories} Geschichten}
	}`,

	'cover.stories': `{itemCount, plural,
		one {Geschichte}
		other {Geschichten}
	}`,

	'searchbutton.placeholder': 'Suche...',

	'flow.empty': 'Es gibt keine Inhalte zum Anzeigen.',

	'search.empty': 'Ihre Suche ergab keine Treffer.',

	'forms.submitted': 'Ihre Eingaben wurden erfolgreich übermittelt.',
	'forms.errored': 'Bei der Übermittlung Ihrer Eingaben ist ein Fehler aufgetreten.',
	'forms.required': 'Dieses Eingabefeld ist vorausgesetzt um das Formular abzuschicken.',
	'forms.close': 'Danke',
	'meta.dateLabel': 'veröffentlicht am ',

	'prevnext.prev': 'Vorherige Geschichte',
	'prevnext.next': 'Nächste Geschichte',

	'navigation.back': 'Zurück',
	
	'share.back': 'Zurück',
	'share.embed': 'Einbetten',
	'share.share': 'Teilen',
	'share.cover': 'Cover',
	'share.custom': 'eigenes Element',
	'share.inline': 'direkt eingebettet',
	'share.customhere': 'HIER IHR EIGENES ELEMENT EINFÜGEN',
	'share.scriptonce': 'Das obige script muss nur einmal pro Seite eingebunden werden',
	'share.FacebookLabel': 'Auf Facebook teilen',
	'share.TwitterLabel': 'Tweeten',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'Einbetten',

	'more.showCollection': 'Alle Geschichten anzeigen',
	'more.showMore': 'Ältere Geschichten anzeigen',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Weitere Inhalte anzeigen',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Alle Geschichten anzeigen',

	'passwordScreen.passwordPlaceholder': 'Passwort',
	'passwordScreen.usernamePlaceholder': 'Benutzername',
	'passwordScreen.subTitle': 'ist eine geschützte {type, select, story {Geschichte} collection {Sammlung}}',
	'passwordScreen.submit': 'Anmelden',
	'passwordScreen.error': 'Anmeldung nicht möglich!',

	'like.label': '{likeCount, number} Gefällt mir',
	'like.noLikeLabel': 'Gefällt mir',

	'forward.title': 'Weiterleitung',
	'forward.message': 'Sie werden zu {href} weitergeleitet.',

	"cookieconsent.message": "Wie viele andere Webseiten benötigen wir Cookies um unsere Services bereit zu stellen und zu verbessern. <br>Welche Arten von Cookies akzeptieren Sie?",
	"cookieconsent.accept": "OK",
	"cookieconsent.acceptAll": "Alle akzeptieren",
	"cookieconsent.denyAll": "Alle ablehnen",
	"cookieconsent.save": "Speichern",
	"cookieconsent.label.functional": "Funktional",
	"cookieconsent.label.statistics": "Statistik",
	"cookieconsent.label.marketing": "Werbung",
	"cookieconsent.details": "Cookie Details",
	"cookieconsent.details.intro": "Sie können jederzeit Ihre Cookie Auswahl abändern oder auch alle gespeicherten Cookies über die Einstellungen Ihres Browsers wieder löschen.",
	"cookieconsent.details.functional": "Diese Cookies werden benötigt, damit diese Webseite sicher und korrekt funktioniert. <em>sessionid, csrftoken, ps-cookie-settings, pagestrip-likes</em>",
	"cookieconsent.details.statistics": "Wir verwenden Google Analytics für unsere Statistik. Zu diesem Zweck muss Google drei Cookies <em>_ga, _gat, _gid</em> mit einer Ablaufzeit von bis zu zwei Jahren anlegen.",
	"cookieconsent.details.marketing": "Bei uns gibt es keine Werbecookies.",
	
};



// WEBPACK FOOTER //
// ./lib/locales/de.js